import systemModals from "components/modals/Modals";

const GenericModal = ({ elementId, modalIsOpen, setModalIsOpen, headerText, bodyText }) =>
  systemModals.customModal(elementId, modalIsOpen, setModalIsOpen, bodyText, headerText);

export default GenericModal;
